export default __webpack_public_path__ + "static/fun2-70ce3f078f30843daf027a2d5ef2198d.png";